module.exports = __webpack_public_path__ + "static/media/Simple_Background.4e87abc2.png";